import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ILoggerDeploymentsState, loggerDeploymentsAdapter, loggerDeploymentsKey } from './logger-deployments.state';

export const selectLoggerDeploymentsState = createFeatureSelector<ILoggerDeploymentsState>(loggerDeploymentsKey);

const { selectAll, selectEntities, selectIds, selectTotal } =
  loggerDeploymentsAdapter.getSelectors(selectLoggerDeploymentsState);

export const selectAllLoggerDeployments = selectAll;
export const selectLoggerDeploymentEntities = selectEntities;
export const selectLoggerDeploymentIds = selectIds;
export const selectLoggerDeploymentsTotal = selectTotal;

export const selectLoggerDeploymentsLoading = createSelector(selectLoggerDeploymentsState, state => state.loading);
export const selectLoggerDeploymentsLoaded = createSelector(selectLoggerDeploymentsState, state => state.loaded);
export const selectLoggerDeploymentsError = createSelector(selectLoggerDeploymentsState, state => state.error);
export const selectPrevLoggerDeploymentsRequest = createSelector(selectLoggerDeploymentsState, state => state.request);
